<template>
  <el-row>
    <el-col :span="12">
      <el-form-item label="文本位置" prop="CheckPos">
        <el-input v-model.trim="value.CheckPos" size="small" />
      </el-form-item>
      <el-form-item label="选择框提示信息" prop="CheckOption">
        <el-input v-model.trim="value.CheckOption" size="small" />
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label="是否选中" prop="IsChecked">
        <el-radio-group v-model="value.IsChecked">
          <el-radio :label="true">是</el-radio>
          <el-radio :label="false">否</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-col>
  </el-row>
</template>

<script>
  export default {
    props: {
      value: Object,
    },
  };
</script>
